// Deteção de transportadora a partir do nome (1.º) ou padrão do código (2.º).
// Devolve { nome, url } ou null se nada bater.

const CARRIERS = {
  ctt:    { nome: 'CTT',    url: (c) => `https://appserver2.ctt.pt/CustomerArea/PublicArea_Detail?IsFromPublicArea=true&ObjectCodeInput=${encodeURIComponent(c)}` },
  dhl:    { nome: 'DHL',    url: (c) => `https://www.dhl.com/pt-en/home/tracking/tracking-parcel.html?submit=1&tracking-id=${encodeURIComponent(c)}` },
  dpd:    { nome: 'DPD',    url: (c) => `https://www.dpd.com/pt/pt/recipient/track-and-trace/?parcelNumber=${encodeURIComponent(c)}` },
  gls:    { nome: 'GLS',    url: (c) => `https://gls-group.com/PT/pt/seguir-encomenda?match=${encodeURIComponent(c)}` },
  ups:    { nome: 'UPS',    url: (c) => `https://www.ups.com/track?tracknum=${encodeURIComponent(c)}` },
  seur:   { nome: 'Seur',   url: (c) => `https://www.seur.com/livetracking/?segOnlineIdentificador=${encodeURIComponent(c)}` },
  nex:    { nome: 'NEX',    url: (c) => `https://www.nexlogistica.com/seguir-envio?codigo=${encodeURIComponent(c)}` },
  poste:  { nome: 'Poste Italiane', url: (c) => `https://www.poste.it/cerca/index.html#/risultati-spedizioni/${encodeURIComponent(c)}` },
  // ONTIME — o transportador do fornecedor de entrega rapida (Espanha).
  //
  // AQUI O CODIGO NAO VAI NO LINK, e nao e por falta de tentar.
  //
  // O seguimento deles nao e uma pagina publica: e um portal Oracle APEX
  // (alina.ontime.es/ords/...) com sessao propria. Passar o numero na
  // querystring — P9999_PEDIDO — nao preenche nada, os campos chegam vazios.
  // Testado. O seguimiento.ontime.es que parecia obvio devolve 403 a toda a
  // gente.
  //
  // Fica o mesmo endereco que o botao "Localize o seu envio" do site deles usa.
  // O cliente aterra na pagina certa e cola o codigo, que esta ao lado do link.
  // E menos do que nas outras transportadoras, mas e o que existe — e continua
  // a ser melhor do que um codigo solto sem sitio para onde ir.
  // O portal e o destino de recurso, para quando so ha o numero do envio: o
  // cliente aterra na pagina certa e cola-o. Com o EUID ha melhor — ver abaixo.
  ontime: { nome: 'ONTIME', url: () => 'https://alina.ontime.es/ords/r/ontime/portalcliente999/login?p9999_tipo=1' },
}

const NAME_ALIASES = {
  ctt: ['ctt', 'correios', 'correios de portugal'],
  dhl: ['dhl'],
  dpd: ['dpd'],
  gls: ['gls'],
  ups: ['ups'],
  seur: ['seur'],
  nex: ['nex', 'logista', 'logista pulse', 'nex logistica'],
  poste: ['poste italiane', 'poste', 'posteitaliane'],
  ontime: ['ontime', 'on time', 'ontime logistica', 'ontimelogistica'],
}

function matchByName(transportadora) {
  if (!transportadora) return null
  const n = String(transportadora).toLowerCase().trim()
  for (const [key, aliases] of Object.entries(NAME_ALIASES)) {
    if (aliases.some(a => n.includes(a))) return key
  }
  return null
}

function matchByCode(codigo) {
  if (!codigo) return null
  const c = String(codigo).trim()
  // CTT — RR123456789PT (registado internacional)
  if (/^[A-Z]{2}\d{9}[A-Z]{2}$/.test(c)) return 'ctt'
  // CTT — DR/CN/EE etc + 9 dígitos + país (variações)
  if (/^(CN|DR|EE|RR|VV)\d{9}[A-Z]{2}$/i.test(c)) return 'ctt'
  // UPS — 1Z + 16 chars
  if (/^1Z[A-Z0-9]{16}$/i.test(c)) return 'ups'
  // DHL — JJD + dígitos
  if (/^JJD\d+$/i.test(c)) return 'dhl'
  // DHL alternativo — só dígitos 10-11
  if (/^\d{10,11}$/.test(c)) return 'dhl'
  // DPD — 14 dígitos
  if (/^\d{14}$/.test(c)) return 'dpd'
  // FedEx — 12 dígitos (não suportada explicitamente, devolve null)
  return null
}

// ONTIME dá um link por envio, com um identificador interno:
//   .../url-seguimiento-destinatario?EUID=593F1427E9760F16E063A414000AAC8F
//
// O EUID não se calcula a partir do número do envio — é gerado por eles. Não há
// como o adivinhar, mas há como o guardar: cola-se o endereço inteiro no campo
// do tracking e daqui em diante o cliente clica e vê a encomenda dele, como em
// qualquer outra transportadora.
//
// Aceita as duas formas: o endereço completo (o que se copia do browser) ou só
// os 32 caracteres do EUID, para quem preferir.
const RE_EUID = /EUID=([0-9A-F]{16,64})/i
const urlOntimeEuid = (euid) =>
  `https://alina.ontime.es/ords/r/ontime/portalcliente999/url-seguimiento-destinatario?EUID=${encodeURIComponent(euid)}`

export function detectTracking(transportadora, codigo) {
  if (!codigo || !String(codigo).trim()) return null
  const bruto = String(codigo).trim()

  // 1) Endereço da ONTIME colado inteiro — extrai-se o EUID e reconstrói-se
  //    limpo, sem o `tz` nem outros restos da sessão de quem o copiou.
  const mEuid = bruto.match(RE_EUID)
  if (mEuid) return { nome: 'ONTIME', url: urlOntimeEuid(mEuid[1]), direto: true }

  // 2) Só o EUID, sem o resto do endereço.
  if (/^[0-9A-F]{32}$/i.test(bruto) && /ontime/i.test(String(transportadora || ''))) {
    return { nome: 'ONTIME', url: urlOntimeEuid(bruto), direto: true }
  }

  // 3) Qualquer outro endereço colado no campo: se é um link, é para seguir.
  //    Vale para transportadoras que ainda não conheçamos.
  if (/^https?:\/\//i.test(bruto)) {
    return { nome: transportadora || 'Seguir envio', url: bruto, direto: true }
  }

  const key = matchByName(transportadora) || matchByCode(codigo)
  if (key && CARRIERS[key]) {
    const c = CARRIERS[key]
    return { nome: c.nome, url: c.url(String(codigo).trim()) }
  }
  // Fallback: pesquisa Google com o código
  return {
    nome: transportadora || 'Tracking',
    url: `https://www.google.com/search?q=${encodeURIComponent(String(codigo).trim() + ' tracking')}`,
    fallback: true,
  }
}
